import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";
import { reportPath } from "../../../ModalRouter/Reports/reportUrl";
import { Reports as LegacyReports } from "../../../ModalRouter/LegacyReports/SideBar/Reports";
import { newReportsEnabled } from "../../../../../utils/features";
import { useWebServer } from "../../../../../providers";
import { loadImagingData } from "../../../../../actions";
import { Reports } from "./Reports";

const Index = ({ loadImagingData, data }) => {
  const { downloadWeeklyImaging } = useWebServer();
  const history = useHistory();

  useEffect(() => {
    loadImagingData(downloadWeeklyImaging);
    //eslint-disable-next-line
  }, []);

  if (!newReportsEnabled()) {
    return (
      <LegacyReports
        data={data}
        handleButtonClick={(button) => history.push(`${ROUTES.reports}?button=${button}`)}
      />
    );
  }

  const handleButtonClick = (slug) => {
    history.push(reportPath(slug));
  };

  return <Reports data={data} handleButtonClick={handleButtonClick} />;
};

export const mapStateToProps = (state) => {
  return {
    data: state?.report?.monthlyData?.data,
  };
};
export default connect(mapStateToProps, { loadImagingData })(Index);
